<script setup lang="ts">
import { computed } from 'vue';

type Direction = 'top' | 'right' | 'bottom' | 'left';

const props = withDefaults(
  defineProps<{
    direction?: Direction | number;
    color1?: string;
    color2?: string;
    borderWidth?: string;
    borderRadius?: string;
    showBorder?: boolean;
  }>(),
  {
    direction: 'right',
    color1: '#f7d038', // Dourado como padrão
    color2: 'rgba(247, 208, 56, 0)', // Dourado transparente
    borderWidth: '3px',
    borderRadius: '0.6rem', // rounded-md
    showBorder: false,
  },
);

const gradientStyle = computed(() => {
  const directionMap: Record<Direction, string> = {
    top: '180deg',
    right: '270deg',
    bottom: '0deg',
    left: '90deg',
  };

  const angle =
    typeof props.direction === 'number'
      ? `${props.direction}deg`
      : directionMap[props.direction];

  return {
    background: `linear-gradient(${angle}, ${props.color1}, ${props.color2})`,
    borderRadius: props.borderRadius,
  };
});
</script>

<template>
  <div class="relative">
    <!-- A "borda" que fica atrás -->
    <div
      v-if="props.showBorder"
      class="absolute inset-0"
      :style="gradientStyle"
    ></div>
    <!-- O conteúdo (card) que fica na frente -->
    <div
      class="relative"
      :style="{
        margin: props.showBorder ? props.borderWidth : '0',
        'border-radius': props.borderRadius,
      }"
    >
      <slot></slot>
    </div>
  </div>
</template>
